var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallBlackLogoAcium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 185 78.1"
    },
    viewBox: "0 0 185 78.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M118.7 33.1c0-4.2-3.4-7.5-7.5-7.5h-18l.9 3.2h17.1c2.5 0 4.5 2 4.5 4.4 0 2.5-2 4.5-4.4 4.5H94.1V41h17.1c2.5 0 4.4 2.1 4.4 4.5s-2 4.4-4.4 4.4H94.1l-.8 2.9h18c4.2 0 7.5-3.4 7.5-7.5 0-2.4-1.2-4.7-3.1-6.1 1.9-1.4 3-3.7 3-6.1zM150.2 45.8l-22.5-20.5v27.5l3.1-.6v-20l22.3 20.5V25.3l-3 .6.1 19.9zM185 25.4h-4.7L165.6 39V25.4h-3v27.3l3-.4V39.1l14.9 13.6h4.6L170 39.1l15-13.7zM0 58.5l9.4-2 14.3-28.4 14.4 28.3 9.5 2.1-23.8-47.2L0 58.5zM70 0h1.2v78.1H70z"
  })), /*#__PURE__*/React.createElement("text", {
    style: {
      fontSize: 11,
      fontFamily: "&quot"
    },
    transform: "translate(92.304 67.485)"
  }, "financial services"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallBlackLogoAcium);
export default __webpack_public_path__ + "static/media/smallBlackLogoAcium.1fe12b5530566e95cc73684f21469728.svg";
export { ForwardRef as ReactComponent };